import { render, staticRenderFns } from "./DragTUICallKit.vue?vue&type=template&id=28732df7"
import script from "./DragTUICallKit.vue?vue&type=script&lang=js"
export * from "./DragTUICallKit.vue?vue&type=script&lang=js"
import style0 from "./DragTUICallKit.vue?vue&type=style&index=0&id=28732df7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports